import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { LandlordTableHttpService } from './landlord-table-http.service';
import * as landlordTableActions from '../actions/landlord-table';
import * as landlordSelectors from '../selectors/landlord-table';
import { State } from '../reducers/landlord-table';
import { Store } from '@ngrx/store';
import { tap, catchError, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { IContext } from '../../context/models/context';
import { ITable } from '../../common/models/table';


@Injectable()
export class LandlordTableService {

  constructor(private readonly landlordTableHttpService: LandlordTableHttpService,
    private readonly store: Store<any>,
    private readonly messageService: ToastrService) { }
  
  loadLandlords(context: IContext): void {
    this.store.dispatch(new landlordTableActions.Load());
    this.landlordTableHttpService.getLandlordTableByContext(context).pipe(
      tap((table: ITable) => {
        this.store.dispatch(new landlordTableActions.LoadComplete(table));
      }),
      catchError(err => {
        this.store.dispatch(new landlordTableActions.LoadError(err));
        this.messageService.error('An error occurred whilst trying to retrieve the table', 'Error', { disableTimeOut: true });
        return [];
      }),
      take(1)
    ).subscribe();
  }

  getLandlordTable(): Observable<ITable> {
    return this.store.select(landlordSelectors.getAllLandlordsWithDataKey);
  }

  getLandlordTableLoading(): Observable<boolean> {
    return this.store.select(landlordSelectors.selectLandlordTableState)
      .pipe(map((state: State) => {
        return state.loading;
      }));
  }

  getLandlordTableError(): Observable<string> {
    return this.store.select(landlordSelectors.selectLandlordTableState)
      .pipe(map((state: State) => {
        return state.error;
      }));
  }

}
